<div class="modal-overlay" *ngIf="modalVisible">
  <div class="modal-content">
    <span class="close text-primary" (click)="closeModal()">&times;</span>
    <div>
      <span class="titulo">{{namepdf}}</span>
      <hr class="linea text-secondary ">
      <pdf-viewer [src]="pdfUrl" [rotation]="0" [original-size]="false" [show-all]="true" [fit-to-page]="false"
        [zoom]="1" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
        [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false"
        style="width: 100%; height: 80vh;"></pdf-viewer>
    </div>
  </div>
</div>